import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";

import { App } from "../../../../routes/Constants";
import useRoles from "../../../../hooks/useRoles";
import { usePrefersReducedMotion } from "../../../../hooks/usePrefersReducedMotion";

const initialShadow = "0px 5px 15px rgba(0, 0, 0, 0.08)";

export const ViewPatientsBox = () => {
  const navigate = useNavigate();
  const { isPrescriber } = useRoles();
  const reduced = usePrefersReducedMotion();

  const goToViewPatients = () => {
    navigate(App.VIEW_PATIENTS);
  };

  const handleCardKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      goToViewPatients();
    }
  };

  return (
    <motion.div
      role="button"
      tabIndex={0}
      data-testid="dashboard-card-view-patients"
      className="group relative flex w-[500px] max-w-full cursor-pointer items-center justify-around gap-2 overflow-hidden rounded-2xl bg-[#d7f8eb] px-8 py-6 shadow-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#00594c]"
      initial={
        reduced
          ? false
          : { opacity: 0, scale: 0.9, boxShadow: initialShadow }
      }
      animate={{ opacity: 1, scale: 1, boxShadow: initialShadow }}
      transition={
        reduced
          ? { duration: 0 }
          : { delay: 0.6, type: "spring", stiffness: 100, damping: 18 }
      }
      whileHover={
        reduced
          ? {}
          : {
            scale: 1.03,
            y: -8,
            boxShadow: "0px 20px 60px rgba(0, 0, 0, 0.15)",
          }
      }
      whileTap={reduced ? {} : { scale: 0.98 }}
      onClick={goToViewPatients}
      onKeyDown={handleCardKeyDown}
    >
      <div
        className="pointer-events-none absolute inset-0 rounded-2xl bg-[rgba(255,255,255,0)] transition-colors duration-300 group-hover:bg-[rgba(255,255,255,0.1)]"
        aria-hidden
      />
      <div className="relative z-[1] max-w-60">
        <motion.p
          className="text-3xl font-semibold leading-tight text-[#00594c]"
          data-testid="dashboard-card-view-patients-title"
          initial={reduced ? false : { opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: reduced ? 0 : 0.8 }}
        >
          View Patients/ Renew PAF
        </motion.p>
        <motion.p
          className="mt-2 text-base font-medium text-[#2f6f66]"
          data-testid="dashboard-card-view-patients-description"
          initial={reduced ? false : { opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: reduced ? 0 : 0.9 }}
        >
          {isPrescriber
            ? "View existing patients and renew PAF"
            : "View patients sent to your pharmacy"}
        </motion.p>
      </div>
      <motion.div
        className="relative z-[1]"
        data-testid="dashboard-card-view-patients-icon"
        initial={reduced ? false : { rotate: 5, opacity: 0 }}
        animate={{ rotate: 0, opacity: 1 }}
        transition={{ duration: reduced ? 0 : 0.8, delay: reduced ? 0 : 0.7 }}
      >
        <motion.div
          whileHover={
            reduced ? {} : { scale: 1.05, rotate: -2 }
          }
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
        >
          <img src="/icons/ViewList.png" alt="View Patients" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};
